module.exports = __webpack_public_path__ + "static/media/americanlife.a892415a.svg";